import styled from 'styled-components';

export const Wrapper = styled.div`
	position: relative;
	width: 100%;
	padding: 24px 0;
`;

export const WrapperGroup = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 80px;

	@media (max-width: 992px) {
		flex-direction: column;
	}
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const Title = styled.div`
	font-size: 32px;
	font-weight: 700;
	line-height: 1.2em;
	color: ${({ theme }) => theme.colors.text.title};

	span {
		color: ${({ theme }) => theme.colors.control.primary};
	}

	@media (max-width: 992px) {
		font-size: 24px;
	}
`;

export const Info = styled.div`
	margin-top: 20px;
	display: flex;
	flex-direction: column;
	gap: 24px;
	justify-content: space-between;
`;

export const Group = styled.div`
	display: flex;
	flex-direction: column;
	gap: 14px;
	align-items: baseline;
	width: 100%;
`;

export const GroupImage = styled.img`
	width: 64px;
	height: 64px;
	object-fit: cover;
	border-radius: 8px;
`;

export const Obj = styled.div`
	display: flex;
	flex-direction: column;
	gap: 15px;
`;

export const ObjTitle = styled.div`
	font-size: 20px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.subtitle};
	line-height: 1.2;
`;

export const Desc = styled.p`
	font-size: 16px;
	color: ${({ theme }) => theme.colors.text.body};
	line-height: 1.4;
	margin: 0;
`;

export const DescList = styled.ul`
	list-style-type: none;
`;

export const DescItem = styled.li`
	color: ${({ theme }) => theme.colors.text.body};
	font-size: 16px;
	line-height: 1.4;
`;

export const ButtonGroup = styled.div`
	display: flex;
	gap: 16px;
	margin-top: 20px;
`;

export const ImageWrapper = styled.div`
	max-width: 614px;
	width: 100%;

	@media (max-width: 992px) {
		margin-top: 24px;
	}
`;

export const Image = styled.img`
	width: 100%;
`;
